module.exports = __webpack_public_path__ + "static/media/25-2.bc49181b.mp3";